<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState,mapGetters,mapActions } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Disbursements",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect
  },
  data() {
    return {
      title: "Disbursements",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Disbursements",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "units",
          sortable: true,
          label: "UNITS",
        },
        {
          key: "agent",
          sortable: true,
          label: "AGENT",
        },
        {
          key: "user.name",
          sortable: true,
          label: "DISBURSED BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DISBURSED ON",
        },
        {
          key: "status",
          sortable: true,
          label: "STATUS",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingProduct: [],
      nameError: "",
      quantityError: "",

     
      // edit unit
      editdata: {
        quantity: "",
        id: "",
      },
      // delete disbursement
      deletedata: {
        id: "",
        product:""
      },
      // receive disbursement
      receivedata: {
        id: "",
        product:""
      },
      // reject disbursement
      rejectdata: {
        id: "",
        product:""
      },

      filterdata:{
        agent:'',
        datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
      },

      currentdate: moment(new Date()).format("YYYY-MM-DD"),

      json_fields: {
        PRODUCT: "product",
        QUANTITY: "quantity",
        UNITS: "units",
        AGENT: "agent",
        DISBURSED_BY: "user.name",
        DISBURSED_ON: "date",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("agentstock", ["SaveStatus", "Disbursements","Agents"]),
    ...mapGetters("auth", ["User"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Disbursements ? this.Disbursements.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Disbursements ? this.Disbursements.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchDisbursement: "agentstock/fetchDisbursement",
      EditDisbursement: "agentstock/editDisbursement",
      DeleteDisbursement: "agentstock/deleteDisbursement",
      ReceiveDisbursement: "agentstock/receiveDisbursement",
      RejectDisbursement: "agentstock/rejectDisbursement",
      FetchAgents: "agentstock/fetchAgents",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingProduct = this.Disbursements.filter((product) => {
          return product.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingProduct.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingProduct = [];
      }
    },
    resetEdit() {
      this.editdata.quantity = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.id = "";
      this.deletedata.product = "";
      this.modal_id = "";
    },

    resetReceive() {
      this.receivedata.id = "";
      this.receivedata.product = "";
      this.modal_id = "";
    },

    resetReject() {
      this.rejectdata.id = "";
      this.rejectdata.product = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.quantityError = "";
    },
    showEditModal(data) {
      this.editdata.quantity = data.item.quantity;
      this.editdata.id = data.item.id;
    },
    editDisbursement(modalId) {
      this.modal_id = modalId;
      if (this.editdata.quantity.length == '') {
        this.quantityError = "The quantity field is required";
        return;
      } else {
        this.quantityError = "";
      }
      this.EditDisbursement(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.id = data.item.id;
      this.deletedata.product = data.item.product;
    },

    showReceiveModal(data) {
      this.receivedata.id = data.item.id;
      this.receivedata.product = data.item.product;
    },

    showRejectModal(data) {
      this.rejectdata.id = data.item.id;
      this.rejectdata.product = data.item.product;
    },

    deleteDisbursement(modalId) {
      this.modal_id = modalId;
      this.DeleteDisbursement(this.deletedata.id);
    },

    receiveDisbursement(modalId) {
      this.modal_id = modalId;
      this.ReceiveDisbursement(this.receivedata.id);
    },

    rejectDisbursement(modalId) {
      this.modal_id = modalId;
      this.RejectDisbursement(this.rejectdata.id);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    FilterReport(){
      this.FetchDisbursement(this.filterdata);
    }

  },
  created() {
    this.FetchDisbursement(this.filterdata);
    this.FetchAgents();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row py-2">
              <div class="col-md-9">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-md-3">
                <download-excel
                  class="btn btn-info mt-4"
                  :data="Disbursements"
                  :fields="json_fields"
                  :worksheet="'STOCK DISBURSEMENTS ' + currentdate"
                  type="csv"
                  :name="'stockdisbursements ' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
            </div>
            <div class="row mb-4">            
              <div class="col-md-3">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="filterdata.datefrom"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="filterdata.dateto"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label>SELECT AGENT</label>
                
                <model-list-select
                  :list="Agents ? Agents : []"
                  v-model="filterdata.agent"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Agent"
                  @input="FilterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="FilterReport()"
                >
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="SaveStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>                
              </div> 
            <!-- End search -->
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Disbursements?Disbursements:[]"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(status)="data">
                <div v-if="data.item.status == 1" class="text-success">Received</div>
                <div v-else-if="data.item.status == 2" class="text-danger">Rejected</div>                
                <div v-else class="text-warning">Pending</div>                
              </template>

                <template #cell(actions)="data">
                  <b-button-group v-if="data.item.status == 0">
                  <b-button
                    v-if="User.role.manage_disbursements == 1 && User.is_agent == 'No'"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-disbursement-modal
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  
                  <b-button
                    v-if="User.role.manage_disbursements == 1 && User.is_agent == 'No'"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-disbursement-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                  <b-button
                    v-if="User.role.manage_disbursements == 1 && User.is_agent == 'Yes'"
                    size="sm"
                    variant="success"
                    v-b-modal.receive-disbursement-modal
                    @click="showReceiveModal(data)"
                    ><i class="fa fa-check"></i> Receive</b-button
                  >
                  <b-button
                    v-if="User.role.manage_disbursements == 1 && User.is_agent == 'Yes'"
                    size="sm"
                    variant="warning"
                    v-b-modal.reject-disbursement-modal
                    @click="showRejectModal(data)"
                    ><i class="fa fa-check"></i> Reject</b-button
                  >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <Loader  v-if="!Disbursements"/>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- edit modal starts -->
    <b-modal id="edit-disbursement-modal" hide-footer @hidden="resetEdit" header-bg-variant="warning">
      <template #modal-title> Edit Disbursement</template>
      <div class="form-group mb-3">
        <label>Quantity <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            @input="resetError()"
            v-model="editdata.quantity"
          />
        </div>
        <div class="text-danger" v-if="quantityError">
          <em>{{ quantityError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('edit-disbursement-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="editDisbursement('edit-disbursement-modal')"
        > <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-disbursement-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title> Delete Product {{ deletedata.product }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this Product? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-disbursement-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-danger"
          @click="deleteDisbursement('delete-disbursement-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal receive disbursement starts -->
    <b-modal
      header-bg-variant="success"
      header-text-variant="light"
      body-text-variant="success"
      footer-bg-variant="success"
      footer-text-variant="success"
      id="receive-disbursement-modal"
      hide-footer
      @hidden="resetReceive"
    >
      <template #modal-title> Receive Product {{ receivedata.product }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to receive this Product? Click Proceed Button to receive.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('receive-disbursement-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-success"
          @click="receiveDisbursement('receive-disbursement-modal')"
        >
          <i class="fa fa-check"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Receiving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal reject disbursement starts -->
    <b-modal
      header-bg-variant="warning"
      header-text-variant="light"
      body-text-variant="warning"
      footer-bg-variant="warning"
      footer-text-variant="warning"
      id="reject-disbursement-modal"
      hide-footer
      @hidden="resetReject"
    >
      <template #modal-title> Reject Product {{ rejectdata.product }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to reject this Product? Click Proceed Button to reject.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('reject-disbursement-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          type="button"
          class="btn btn-warning"
          @click="rejectDisbursement('reject-disbursement-modal')"
        >
          <i class="fa fa-check"></i> Proceed
          <b-spinner
            v-if="SaveStatus"
            variant="light"
            small
            label="Rejecting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
